import { Outlet } from '@tanstack/react-router';
import Loader from '@zeus/core/Loader';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import FlowSection from '_/common/components/layout/FlowSection';
import { useFlowContext } from '_/contexts/FlowContext';
import useDocumentTitle from '_/hooks/useDocumentTitle';
import React, { ReactElement, useMemo, Suspense } from 'react';

function FlowPageContent(): ReactElement {
  const { selectedFlow, isLoading, projectId, flowSlug } = useFlowContext();

  const { id, name } = selectedFlow || {};
  const title = useMemo(() => `${name || 'Flow'} :: ${location.pathname.split('/').pop()}`, [name]);

  useDocumentTitle(title);

  // Only show loader if we're expecting a flow (flowSlug exists) but it hasn't loaded yet
  // For new flow creation (no flowSlug), allow the page to render immediately
  const isPageLoading = flowSlug ? !id || !projectId || isLoading : !projectId || isLoading;

  return (
    <Suspense fallback={<Loader />}>
      <AsyncPageContainer isLoading={isPageLoading}>
        <Outlet />
      </AsyncPageContainer>
    </Suspense>
  );
}

function FlowPage(): ReactElement {
  return (
    <FlowSection>
      <FlowPageContent />
    </FlowSection>
  );
}

export default FlowPage;
